import React from 'react';
import style from './section.module.pcss';

interface SectionProps {
  title?: string;
  children: React.ReactChild;
}

function Section({ title, children }: SectionProps): React.ReactElement {
  return (
    <div className={style.section}>
      {title && <h6 className={style.section__title}>{title}</h6>}
      {children}
    </div>
  );
}

export default Section;
